import { render, staticRenderFns } from "./LearningCoursesPage.vue?vue&type=template&id=625f860d&scoped=true&"
import script from "./LearningCoursesPage.vue?vue&type=script&lang=ts&"
export * from "./LearningCoursesPage.vue?vue&type=script&lang=ts&"
import style0 from "./LearningCoursesPage.vue?vue&type=style&index=0&id=625f860d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f860d",
  null
  
)

export default component.exports